import styled from "styled-components";

/**
 * FeatureItem
 * Reusable icon + text item for horizontal feature strips.
 *
 * Props:
 * - text (string)               : The blurb under the icon (required)
 * - icon (ReactNode)            : Optional React element (e.g., inline SVG or <Icon />)
 * - imgSrc (string)             : Optional URL/path to an image icon (used if no `icon`)
 * - imgAlt (string)             : Alt text for the image icon
 * - size (number)               : Icon size in px (default 56)
 */


interface FeatureItemProps {
  text?: string;
  icon?: any;
  imgSrc?: string;
  imgAlt?: string;
  size?: number;
}

const FeatureItem = ({ text="test", icon, imgSrc, imgAlt= "", size= 56 }: FeatureItemProps) => {
    return <FeatureItemContainer>
      <IconWrapContainer style={{ width: size, height: size }}>
        {icon ? (
          <IconNode aria-hidden="true">
            {icon}
          </IconNode>
        ) : imgSrc ? (
          <IconImg
            src={imgSrc}
            alt={imgAlt}
            width={size}
            height={size}
            loading="lazy"
          />
        ) : null}
      </IconWrapContainer>
      <FeatureDescription >{text}</FeatureDescription>
    </FeatureItemContainer>
  };

const FeatureItemContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
  padding: 8px 4px;
  max-width: 260px; /* keeps it to ~2 lines like the screenshot */
`;

const IconWrapContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Soft gray */
  color: #bdbdbd;
  /* For <img> fallback we’ll apply grayscale via the image class */
`
const IconNode = styled.span`
  /* Ensure inline SVGs scale to the provided size */
  width: 100%;
  height: 100%;
`
const IconImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: grayscale(100%) brightness(0.9);
  opacity: 0.9;
`
const FeatureDescription = styled.p`
  margin: 0;
  color: #8a8a8a;
  line-height: 1.35;
  font-size: 13px;
`
export default FeatureItem;